// extracted by mini-css-extract-plugin
export default {"header":"ShiftModalHeader--header--2f88fa","image":"ShiftModalHeader--image--04f1bf","title":"ShiftModalHeader--title--e7de38","date":"ShiftModalHeader--date--16c2c0"};